<template>
<div class="list-wrapper grid-x align-center">
  <div class="cat-wrapper cell medium-10 large-7">
   <label v-for="cat in categories"><input type="checkbox" @change="catSelected(cat.id, this)" :value="cat.id" :class="isChecked(cat.id) ? 'active' : ''" v-model="checkedInputs"><span class="label-wrapper">{{cat.name}}</span></label>
  </div>
</div>
</template>

<script>
export default {
  props: ["categories", "preselectedCats"],
  data: function() {
    return {
      checkedInputs:[-1],
      currentItem: -1,
      // preselectedCats:[],
    };
  },
  mounted(){
    let hash = document.location.hash.toString();
    if (hash.indexOf("#!") === 0) {
      let spl = hash.split("#!");
      if (spl.length == 2) {
        let ids = spl[1].split(","); 
        let intIds = [];
        for (let i = 0; i < ids.length; i++) {
          intIds.push(parseInt(ids[i],10));
        }
        this.checkedInputs = intIds;
      }
    }

    if (this.preselectedCats.length) {

      this.checkedInputs = this.preselectedCats;
    }
  },
  watch: {
    preselectedCats:function(value){
      this.checkedInputs = [parseInt(value,10)];
    }
  },
  computed: {
    
  },
  methods: {
    isChecked:function(id){
      return this.checkedInputs.indexOf(id) >= 0;
    },
    catSelected(id, e) {
      this.currentItem = id;

      //Poista "Kaikki"-valinta jos valittuna on jokin muu
      if (id >= 0) {
        let removeIndex = this.checkedInputs.indexOf(-1);
        if (removeIndex >= 0) {
          this.checkedInputs.splice( removeIndex , 1 );
        }
      }
      //Jos "KAIKKI" -nappi valittuna, poista muut
      else if (id == -1) {
        this.checkedInputs = [-1];
        this.$el.querySelectorAll("input[type='checkbox']").forEach((item) => {
          if (item.value != -1) {
            item.checked = false;
          }
        })
      }

      document.location.hash = "#!" + this.checkedInputs.join(",");
      log("checkedInputs", this.checkedInputs);
      this.$emit("activeCategoryChanged", this.checkedInputs);
    },
    finLang() {
      if (window.SITE_LANG == "fi") {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
